import PropTypes from 'prop-types';
import { useState } from 'react';

import { AvatarImage } from '../../Avatar';
import AvatarUploadAndCropModal from '../workspace-upload-modal';
import Button from '../../atoms/button';

const UploadAvatarCard = (props) => {
  // init
  const { name, title, avatar, uploadButtonText, isOptional, onUpload, onRemove, cancelButtonText = 'Remove', isUploading, setIsUploading, alt } = props;

  // states
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenDialog = () => {
    setIsOpen(true);
  };

  return (
    <div className="border-card">
      <span className="border-card-title">
        {title}
        {isOptional && <span className="optional-text"> (optional)</span>}
      </span>
      <div className="upload-avatar-container">
        <AvatarImage borderGray placeHolder="" alt={alt} name={name} src={avatar} fontSize={35} height={80} width={80} />
        <Button primary outlined onClick={handleOpenDialog}>{uploadButtonText}</Button>
        {avatar && <Button danger outlinedColor onClick={onRemove}>{cancelButtonText}</Button>}
        <AvatarUploadAndCropModal isUploading={isUploading} setIsUploading={setIsUploading} isOpen={isOpen} setIsOpen={setIsOpen} setAvatar={onUpload} />
      </div>
    </div>
  );
};

UploadAvatarCard.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  uploadButtonText: PropTypes.string.isRequired,
  isOptional: PropTypes.bool,
  avatar: PropTypes.string,
  onRemove: PropTypes.func.isRequired,
  onUpload: PropTypes.func.isRequired,
  cancelButtonText: PropTypes.string,
  isUploading: PropTypes.bool,
  setIsUploading: PropTypes.func,
  alt: PropTypes.string,
};

export default UploadAvatarCard;
